/**
 * User: daletan
 * Date: 7/21/14
 * Time: 1:21 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * moved from: 1stdibs.com/dibs/assets/js/global/core/commonjs/dibsCookies.js
 *
 * formerly:
 * js/global/core/dibs.js#cookieDomain
 * js/global/core/dibs.js#defaultCookieSettings
 * js/global/core/dibs.js#cookies
 *
 * dibs.cookieDomain
 * dibs.defaultCookieSettings
 * dibs.cookies
 */

'use strict';

var root = require('./windowCheck');
var doc = root.document || {};
var location = doc.location || {};
var hostName = location.hostname || '';
var cookies = doc.cookie || '';
var exports = {};

/**
 * Still expose this for testing
 */
exports.cookieDomainFn = function (d) {
    var arr = d.split('.');
    var len = arr.length;
    var str = ".";

    if (len > 2) {
        str += arr[len - 2] + '.' + arr[len - 1];
    } else {
        str += arr.join('.');
    }
    return str;
};

/**
 * Still expose this for testing, though this one is tough for testing
 * since it cookies can change from env to env
 */
exports.cookiesFn = function () {
    var x = cookies.split(';');
    var len = x.length;
    var c = {};
    var value;
    var key;
    while (len--) {
        value = x[len].split('=');
        key = value.shift().replace(/(^\s+|\s+$)/g, '');
        c[key] = decodeURIComponent(value.join('='));
    }
    return c;
};

exports.TEST_COOKIE = 'testcookie';

exports.isEnabled = function () {
    var isCookiesEnabled;
    if (this.getCookie().indexOf(this.TEST_COOKIE + '=') > -1) {
        return true;
    }
    this.setCookie(this.TEST_COOKIE + "=1");
    isCookiesEnabled = this.getCookie().indexOf(this.TEST_COOKIE) > -1;
    this.setCookie(this.TEST_COOKIE + "=1; expires=Thu, 01-Jan-1970 00:00:01 GMT");
    return isCookiesEnabled;
};

// wrapper for test mocking
exports.getCookie = function () {
    return doc.cookie;
};

// wrapper for test mocking
exports.setCookie = function (cookie) {
    doc.cookie = cookie;
};

exports.cookieDomain = exports.cookieDomainFn(hostName);
exports.cookies = exports.cookiesFn();

exports.defaultCookieSettings = {
    path : '/',
    domain : exports.cookieDomain
};

module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/dibsCookies.js
// module id = 749
// module chunks = 63